var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"component-fade","mode":"out-in"}},[_c('div',{staticClass:"mask"},[_c('div',{staticClass:"mask_tips"}),_vm._v(" "),_c('div',{staticClass:"mask_in"},[_c('i',{on:{"click":_vm.closeMask}}),_vm._v(" "),_c('p',[_vm._v("系统提示")]),_vm._v(" "),_c('span',[_vm._v("很抱歉，當前頁面服務僅對港澳台地區用戶開放")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a7456f9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mask.vue
// module id = null
// module chunks = 